import last from 'lodash/last'
import includes from 'lodash/includes'
import { translate } from 'loankeeper-common/helpers'

const getTranslateKey = (formName, objectName, column) => `${formName}-${objectName}.${column}`

export const translateColName = (formName, objectName, column) => {
  const key = getTranslateKey(formName, objectName, column)

  const translatedTxt = translate(key)

  if (includes(key, translatedTxt)) {
    const splitTranslatedTxt = translatedTxt.split('.')

    if (splitTranslatedTxt.length < 3) {
      return last(splitTranslatedTxt)
    }

    return splitTranslatedTxt.slice(1).join('.')
  }

  return translatedTxt
}

export const translateMain = (key) => translate('frm_Main', key)
export const translateAggregates = (key) => translate('frm_aggr_view', key)

export const getGridIdentity = (formName, objectName, customID = null) =>
  `${formName}-${objectName}${customID ? `-${customID}` : ''}`
